import { FC, ReactNode } from 'react';
import { Container, Box } from '@mui/material';
import ShowTotalsReport from 'src/components/reports/ShowTotalsReport';

declare interface Props {
  children?: ReactNode;
}

const ReportsContainer: FC<Props> = () => {
  return (
    <>
      <Box sx={{ mt: 6 }}>
        <Container maxWidth={'xl'}>
          <ShowTotalsReport />
          <Box sx={{ mt: 2 }}></Box>
        </Container>
      </Box>
    </>
  );
};

export default ReportsContainer;
